export default "__VITE_ASSET__DoDMsW$c__"